// Labelled text input in the inked-paper style.

import { forwardRef } from "react";
import type { InputHTMLAttributes } from "react";

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

export const Field = forwardRef<HTMLInputElement, FieldProps>(function Field(
  { label, id, className, ...rest },
  ref,
) {
  const inputId = id ?? rest.name ?? label.toLowerCase().replace(/\s+/g, "-");
  return (
    <label htmlFor={inputId} className="block">
      <span className="mb-1.5 block text-sm font-semibold text-ink-soft">{label}</span>
      <input
        id={inputId}
        ref={ref}
        className={
          "w-full rounded-xl border-2 border-ink/25 bg-paper-deep px-4 py-3 text-ink " +
          "placeholder:text-ink-muted/70 transition-colors " +
          "focus:border-citrus focus:bg-paper focus:outline-none " +
          (className ?? "")
        }
        {...rest}
      />
    </label>
  );
});
